import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsComponent } from './settings.component';
import { MaterialModule } from 'src/app/material.module';
import { StatusModule } from 'src/app/platform/nomenclatoare/status-cerere/status.module';
import { CererePriorityModule } from 'src/app/platform/nomenclatoare/cerere-priority/cerere-priority.module';
import { RequestTypesModule } from 'src/app/platform/nomenclatoare/cerere-type/cerere-type.module';
import { CerereSabloaneModule } from 'src/app/platform/nomenclatoare/cerere-sabloane/cerere-sabloane.module';
import { FunctiiModule } from 'src/app/platform/nomenclatoare/functii/functii.module';
import { JudetModule } from 'src/app/platform/nomenclatoare/judet/judet.module';
import { DocumentCategoryModule } from 'src/app/platform/nomenclatoare/document-category/document-category.module';
import { DocumentTypeModule } from 'src/app/platform/nomenclatoare/document-type/document-type.module';
import { DocumentTemplateModule } from 'src/app/platform/nomenclatoare/document-template/document-template.module';
import { RegistreModule } from 'src/app/platform/nomenclatoare/registre/registre.module';
import { OperatoriModule } from 'src/app/platform/nomenclatoare/operatori/operatori.module';
import { NomenclatoareModule } from 'src/app/platform/nomenclatoare/nomenclatoare.module';
import { ZileLibereModule } from 'src/app/platform/nomenclatoare/zile libere/zile-libere.module';

@NgModule({
  declarations: [SettingsComponent],
  imports: [
    CommonModule,
    MaterialModule,
    StatusModule,
    RequestTypesModule,
    CererePriorityModule,
    CerereSabloaneModule,
    FunctiiModule,
    JudetModule,
    DocumentCategoryModule,
    DocumentTypeModule,
    DocumentTemplateModule,
    RegistreModule,
    OperatoriModule,
    ZileLibereModule,
  ],
  exports: [SettingsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SettingsModule {}
